import { connect } from '@common/components/base.component';
import React, { Component } from 'react';
import Fab from '@common/externos/components/fab/fab.externo';
import { Row, Col } from 'react-bootstrap';
import Typography from '@material-ui/core/Typography';
import api from '../service/servicoRedeSIM.service';
import ModalInstitucional from '@/modules/common/institucionalModal/containers/institucional.modal';

class Container extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modulos: [],
    };
  }

  async componentDidMount() {
    const responseSistemas = await api.getsistemasHabilitadosPortalCidadao();
    let redeSim = responseSistemas.data.find((x) => x.Nome == 'Serviços Rede SIM');

    const response = await api.getModulosAtivosByIdSistema();
    this.setState({ modulos: response.data, ativo: redeSim?.Ativo == 'Sim' });
  }

  redirect({ Alias, State: name }) {
    const { routerManager } = this.props;
    routerManager.redirect({ name });
  }

  render() {
    const { modulos, ativo } = this.state;

    if (!ativo)
      return (
        <div className="text-center text-muted p-5">
          <Typography>Sistema desabilitado.</Typography>
        </div>
      );

    if (!modulos.length)
      return (
        <div className="text-center text-muted p-5">
          <Typography>Não existem módulos habilitados para a Rede SIM.</Typography>
        </div>
      );

    return (
      <>
        <ModalInstitucional />
        <Row>
          {modulos.map(
            (modulo, index) =>
              modulo.Ativo && (
                <Col xs={12} lg={4} key={index}>
                  <Fab title={modulo.Nome} icon={`fas fa-${modulo.Icone}`} onClick={() => this.redirect(modulo)} />
                </Col>
              )
          )}
        </Row>
      </>
    );
  }
}

export default connect()(Container);
